module.exports = __webpack_public_path__ + "static/media/Sync_pending.70284f1e.svg";